import { IModelRaw } from './base';

export enum ETrackType {
  Startup = 'Startup',
  Investor = 'Investor',
  Researcher = 'Researcher',
}

export interface IFaq extends IModelRaw {
  question_en: string;

  question_vi: string;

  answer_en: string;

  answer_vi: string;

  track: ETrackType;

  weight: number;
}
